module.exports = __webpack_public_path__ + "img/CX.53d819e3.svg";